export default "__VITE_ASSET__BsQo9G2h__"